import { VFC } from 'react';
import { PhotoConfigShape } from 'routes/installation/const/config/photo';
import { ImageUpload, ImageUploadProps } from '../../../../components/ImageUpload/ImageUpload';
import { FormItem } from '../../../../components/Form/FormItem';
import { useStore } from '../../useStore';

export const PhotoUploader: VFC<PhotoConfigShape> = ({ help, label, formItemName, required = true }) => {
  const store = useStore();
  type InstallationMeterStoreKey = keyof typeof store;
  const fileList = store[formItemName as InstallationMeterStoreKey];

  return (
    <FormItem
      shouldUpdate
      help={help}
      initialValue={fileList}
      label={label}
      name={formItemName}
      rules={[
        {
          required,
        },
      ]}
      trigger={'onImageUpload' satisfies keyof ImageUploadProps}
      valuePropName={'fileList' satisfies keyof ImageUploadProps}
    >
      <ImageUpload multiple name={formItemName} />
    </FormItem>
  );
};
